module.exports = __webpack_public_path__ + "assets/img/Sustainable_001.28971f19.svg";